import React from 'react'
import {Route} from 'react-router-dom'

import StorageListPage from './pages/StorageListPage/StorageListPage';
import { ROUTE_DASHBOARD_ASSET_CONTROL_REGISTRY_STORAGE, ROUTE_DASHBOARD_ASSET_CONTROL_REGISTRY_STORAGE_EDIT, ROUTE_DASHBOARD_ASSET_CONTROL_REGISTRY_STORAGE_CREATE } from '../../../../../../../../constants/route-constant';
import StorageChangePage from './pages/StorageChangePage/StorageChangePage';

class StoragePage extends React.Component {
  render () {
    return (
      <div
        style={{
          height: '100%',
          width: '100%'
        }}
      >
        <Route
          exact
          path={ROUTE_DASHBOARD_ASSET_CONTROL_REGISTRY_STORAGE}
          render={props => (<StorageListPage {...props} />)}
        />

        <Route
          path={ROUTE_DASHBOARD_ASSET_CONTROL_REGISTRY_STORAGE_CREATE}
          render={props => (<StorageChangePage {...props} />)}
        />

        <Route
          path={ROUTE_DASHBOARD_ASSET_CONTROL_REGISTRY_STORAGE_EDIT}
          render={props => (<StorageChangePage {...props} />)}
        />
      </div>
    )
  }
}

export default StoragePage
